import React from 'react';
import clientInformation from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, CheckCustomerData } from "../../services/AuthenticationService";
import { useParams } from 'react-router-dom';
import { onlyNumbers, BonusString } from '../helpers/common';
import { EWalletDeposit, GetPendingTrx, EWalletConfirm } from "../../services/DepositService";
import Bonus from '../Bonus';
import { isMobile } from 'react-device-detect';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import iframeResizer from 'iframe-resizer';

export const TwoStepMethods = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    let url = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const { id } = useParams();
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(localStorage.getItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [arrayPendingTrx, setArrayPendingTrx] = useState([]);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [, updateState] = React.useState();
    const [TransactionID, setTransactionID] = useState('');
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [arrayEwallet, setArrayEwallet] = useState([]);
    const [isValidate, setIsValidate] = useState(true);
    const [isSecureIdVisible, setIsSecureIdVisible] = useState(false);
    const [isAccountVisible, setIsAccountVisible] = useState(false);
    const [height, setHeight] = useState('900px');
    const iframeRef = React.useRef();

    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(function (response) {
            validateFields();
            doCheckCustomerData();
            doGetPendingTrx();
        })
            .catch(function (error) {
                navigate('/expired/');
            })
        if (arrayRegularDeposits == undefined) {
            navigate('/deposits/');
        }
    }, [])


    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    async function doGetPendingTrx() {
        await GetPendingTrx(localStorage.getItem('Token'), arrayRegularDeposits.ProcessorID).then(async function (response) {
            var i = 0;
            const filtered = response.Authentication.tnxList.map(item => {
                const {
                    Amount,
                    TransactionID,
                    ExternalID,
                    dateCreated } = item;

                return {
                    Key: i++,
                    Amount,
                    TransactionID,
                    ExternalID,
                    dateCreated
                }
            });
            setArrayPendingTrx(filtered);

        })
            .catch(function (error) {


            })

    }

    async function validateFields() {
        switch (arrayRegularDeposits.ImageName.toLowerCase()) {
            case "triplewallet":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            default:
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(true);
                }
                break;
        }
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(localStorage.getItem('Token'), arrayRegularDeposits.DepositID).then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    if (isValidate) {
        return <MissingAccountInfo Processor={arrayRegularDeposits.DepositID} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    async function doEWalletDeposit(Amount, Account, SecureID) {

        var Data =
        {
            "Token": localStorage.getItem('Token'),
            "eWalletAccount": Account,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayRegularDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": "USD",
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(JSON.parse(localStorage.getItem('ArrayBonus')))
        };

        await EWalletDeposit(Data).then(function (response) {

            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                        message += response.Authentication.Descriptor;

                        if (isMobile) {
                            Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                        }
                        else {
                            Alerts.ShowAlert('Deposit Pending', message, 'info');
                        }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Rejected', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making deposit', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                }

            })


    }

    async function doEWalletConfirm(TransactionID) {
        var Data =
        {
            "Token": localStorage.getItem('Token'),
            "TransactionID": TransactionID
        };

        await EWalletConfirm(Data).then(function (response) {

            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with Deposit', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with Deposit', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                    message += response.Authentication.Descriptor;

                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Deposit Pending', message, 'info');
                    }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Rejected', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making deposit', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                }

            })
    }

    const submitOtherDepositStep1 = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountoremail, secureid } = Object.fromEntries(data.entries());
            if (amount != '') {
                setIsProcessing(true);
                await doEWalletDeposit(amount, accountoremail, secureid);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }
        }
    }

    const submitOtherDepositStep2 = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            setIsProcessing(true);
            await doEWalletConfirm(TransactionID);
            setIsProcessing(false);
        }
        else {
            Alerts.ShowAlert('Warning', 'Amount required', 'warning');
        }
    }
    

    return (
        <div className="componentload">
           
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> Deposit using {id}
                    </span>
                </div>
               
                <div >
                    <form onSubmit={submitOtherDepositStep2} >
                        <div className="row mb-4">
                            <div className="col-md-1 d-none d-md-block"></div>
                            <div className="col-md-10 col-sm-12">
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header ">
                                            <button className="accordion-button  text-center" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                <i className="fa fa-info-circle fa-2x " aria-hidden="true"></i> Click here to confirm a&nbsp;&nbsp;<b>zelle deposit</b>
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse hide" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3 col-sm-12 col-xs-12">
                                                        <label className="mt-2" >Pending Zelle confirmations:</label>
                                                    </div>

                                                    <div className="col-md-9 col-sm-12 col-xs-12">
                                                        <table className="transaction-result table">
                                                            <thead className="bg-primary">
                                                                <tr>
                                                                    <th><center className="">Tnx ID</center></th>
                                                                    <th className="text-center">Code</th>
                                                                    <th className="text-center">Amount</th>
                                                                    <th><center className="d-none d-md-block">date</center></th>
                                                                </tr>
                                                            </thead>
                                                            {arrayPendingTrx.map((item) => (
                                                                <tbody>

                                                                    <tr key={item.Key} ng-repeat="item in TransactionHistoryList" className="ng-scope">
                                                                        <td className="" onChange={(event) => { setTransactionID(event.target.value) }}>
                                                                            <input type="radio" name="radgroup" ng-model="tnxlist.selectedOption" ng-value="item.TransactionID" className="ng-pristine ng-untouched ng-valid ng-not-empty" value={item.TransactionID} />&nbsp;{item.TransactionID}
                                                                        </td>
                                                                        <td className="text-center">{item.ExternalID}</td>
                                                                        <td className="text-center">{item.Amount}</td>
                                                                        <td><center className="d-none d-md-block">{item.dateCreated}</center></td>
                                                                    </tr>

                                                                </tbody>
                                                            ))}
                                                        </table>
                                                    </div>
                                                </div>
                                                {/*<div className="row mb-4">*/}
                                                {/*    <div className="col-md-3 col-sm-12">*/}
                                                {/*        <label for="controlnumber" >Confirmation Number:</label><br />*/}
                                                {/*    </div>*/}
                                                {/*    <div className="col-md-4 col-sm-12">*/}
                                                {/*        <input type="text" onKeyPress={(event) => id == "moneygram" ? onlyNumbers(event) : event} className="form-control border-teal" aria-label="Control Number"*/}
                                                {/*            placeholder="confirmation number" name="ControlNumber" maxlength={id == "moneygram" ? 8 : 14} minlength={id == "moneygram" ? 8 : 6} />*/}
                                                {/*        <span className="text-danger">Confirmation number required.</span>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4" ng-click="submitOtherDepositStep2()">Complete</button>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1 d-none d-md-block"></div>
                        </div>
                    </form>
                    <form onSubmit={submitOtherDepositStep1} >
                        <div className="row">
                            <div className="col-md-1 d-none d-md-block"></div>
                            <div className="col-md-10 col-sm-12" style={{ verticalAlign: "middle" }}>
                                <div className="col-md-12 col-sm-12">
                                    <div className="row">
                                        {isSecureIdVisible && <div className="col-md-12 clear row-12" >
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">SecureID:</label>
                                                <div className="col-md-7 col-sm-7 col-xs-12">
                                                    <input type="password" className="form-control" name="secureid"
                                                        aria-label="secure id" placeholder="SecureID" required />
                                                </div>
                                            </div>
                                        </div>}
                                        {isAccountVisible && <div className="col-md-12 clear row-12 mb-4">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">Account:</label>
                                                <div className="col-md-7 col-sm-7 col-xs-12">
                                                    <input type="text" className="form-control" name="accountoremail"
                                                        aria-label="account or email" placeholder="Account" required />
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <div className="col-md-12 m3 ">

                                                <div className="input-group mb-3  ">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                                                <select className="form-control selectcurrency" disabled name="CurrencyCode" required value={clientInfo.CurrencyCode == 'mBTC' ? 'USD' : clientInfo.CurrencyCode}>
                                                                    <option value="" className="">Currency</option>
                                                                    <option selected value="USD">USD</option>
                                                                    <option value="EUR">EUR</option>
                                                                    <option value="GBP">GBP</option>
                                                                    <option value="CAD">CAD</option>
                                                                </select>
                                                            </span>
                                                        </div>
                                                        <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Enter amount here" max={arrayRegularDeposits?.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits?.MaxDeposit} min={arrayRegularDeposits?.MinDeposit === 0 ? 1 : arrayRegularDeposits?.MinDeposit} name="amount" required="" />
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                                                    Deposit Limits: Minimum {arrayRegularDeposits.MinDeposit == 0 ? 1 : arrayRegularDeposits.MinDeposit} USD Maximum {arrayRegularDeposits.MaxDeposit == 0 ? 'No Limit' : arrayRegularDeposits.MaxDeposit + ' USD'}
                                                </div>
                                            </div>

                                        </div>
                                        <Bonus ProcessorName={id} />
                                        <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                                            <button type="button" className="btn btn-secondary btn-gray btn-back-order" onClick={() => navigate('/deposits/')}>BACK</button>
                                            <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">GET NEW INSTRUCTIONS</button>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="col-md-1 d-none d-md-block"></div>
                        </div>
                    </form>
                </div>
                {/*<div className="row">*/}
                {/*    <div className="col-md-12 col-sm-12 col-xs-12 " >*/}

                {/*    </div>*/}
                {/*    <div className="col-md-12 mb-3-small mt-4 actionbuttons">*/}
                {/*        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>BACK</button>*/}
                {/*        {!showiFrame && <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">DEPOSIT</button>}*/}
                {/*    </div>*/}
                {/*</div>*/}
           
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>

    );
}